import type { SubscribeAction, SubscribeActionWithArgs } from './redux/types';

import useLanguageSender from './hooks/use-language-sender';
import { initializeWebSockets } from './hub';
import mainHubInstance from './hub/main-hub';
import signalrReducer, { type SignalrState } from './redux/reducer';
import signalRSaga from './saga';

// ---

export * from './saga/get-data-from-hub/dialog';
export * from './redux/actions/connection';
export * from './redux/actions/subscribe-to-matches';
export * from './redux/selectors';

export {
  mainHubInstance,
  initializeWebSockets,

  signalrReducer,
  SignalrState,
  SubscribeAction,
  SubscribeActionWithArgs,
  useLanguageSender,

  signalRSaga,
};
